'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Image } from '@/components/client';
import { WELLO_IMAGE_PREFIX_URL } from '@/constants';
import { FriendInviteShareDrawer } from '../../_components/FriendInviteShareDrawer';
const IMAGE_BASE = `${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market`;
export const StepSection = () => {
  const $ = _c(9);
  const [isShareDrawerOpen, setIsShareDrawerOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-40 items-center justify-center rounded-pill bg-[#f6e0cf] px-20 py-8"><p className="text-center font-700 text-[#c21511] typo-body1">STEP 1</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-center font-600 text-Gray-white typo-body2">아직 웰로를 모르는 친구가 있다면,<br />카카오톡으로 초대해 주세요!</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col items-center gap-20">{t0}{t1}<button type="button" className="relative aspect-[335/260] w-full overflow-hidden rounded-xlarge" onClick={() => setIsShareDrawerOpen(true)}><Image src={`${IMAGE_BASE}/invite-step-1.png`} alt={"\uCE74\uCE74\uC624\uD1A1 \uCE5C\uAD6C \uCD08\uB300\uD558\uAE30 \uBC84\uD2BC \uC548\uB0B4"} fill={true} sizes="(max-width: 1279px) 100vw, 335px" className="object-cover" /></button></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex h-40 items-center justify-center rounded-pill bg-[#f6e0cf] px-20 py-8"><p className="text-center font-700 text-[#c21511] typo-body1">STEP 2</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-center font-600 text-Gray-white typo-body2">초대된 친구가 웰로 가입 후<br />웰로 고향사랑기부제 참여하면 완료!</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col items-center gap-20">{t3}{t4}<div className="relative aspect-[335/377] w-full overflow-hidden rounded-xlarge"><Image src={`${IMAGE_BASE}/invite-step-2.png`} alt={"\uB098\uC5D0\uAC8C 2\uCC9C\uC6D0\xD7\uBB34\uC81C\uD55C, \uCE5C\uAD6C\uC5D0\uAC8C 1\uCC9C\uC6D0+\uCD94\uAC00 \uD61C\uD0DD \uC548\uB0B4"} fill={true} sizes="(max-width: 1279px) 100vw, 335px" className="object-cover" /></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsShareDrawerOpen(false);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isShareDrawerOpen) {
    t7 = <section className="w-full bg-Gray-black"><div className="mx-auto flex max-w-[375px] flex-col gap-48 px-20 py-60">{t2}{t5}<FriendInviteShareDrawer opened={isShareDrawerOpen} onClose={t6} /></div></section>;
    $[7] = isShareDrawerOpen;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};